



































































































































































































































































































































import axios from 'axios';
import Fiscal from '@/components/Fiscal.vue';
import TipoComprobante from '@/components/TipoComprobante.vue';
import Entidad from '@/models/Entidad.vue';
import { randomBytes } from 'crypto';

export default {
	name: 'fiscales',
	inject: ['responsive'],
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			radio: 1,
			showBtnMore: false,
			recordSelected: {
				importe_con_formato: '',
				fecha: '',
				fecha_vencimiento: '',
				descomlarga: '',
				tvdgi: '',
				letra: '',
				codcom: '',
				codtal: '',
				numero: '',
				detalle: '',
				renglonesProductos: [],
				renglonesOtros: [],
				imprime: 0,
			},
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			tableProductos: false,
			tableOtros: false,
			loading: true,
			//resumen: '',
			scrollPosition: 0,
			descom: '',
			resumenes: [],
			searchForm: {
				fechaDesde: '',
				fechaHasta: '',
				fechaDesdeM: '',
				fechaHastaM: '',
				comprobantes: [],
				rangofecha: '',
			},
			start: 0,
			limit: 7,
			searchRules: {
				fechaDesde: [{ type: 'date', required: true, message: 'Seleccione una fecha desde', trigger: 'change' }],
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
			},
		};
	},
	watch: {
		$route(to, from): void {
			this.loadDataResumen();
		},
	},
	computed: {
		tituloResumen(): String {
			return this.$route.name;
		},
		detalle(): String {
			return `<p style= margin:0>${this.detalle}<br>${this.detalle1}<br>${this.detalle2}<br>${this.detalle3}</p>`;
		},
		tableData(): Fiscal[] {
			return this.$store.state.remitos.tableData;
		},
		tipodecomprobantes(): TipoComprobante[] {
			return this.$store.state.remitos.tipocomprobantes;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
	},
	filters: {
		capitalize: function (value: string) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
	},
	methods: {
		disabledDateD(date: Date): boolean {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date: Date): boolean {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		stylerow({ row, rowIndex }): string {
			return `style-${row.estilo}`;
		},
		validDates(fecha: Date): void {
			let date = new Date();
			date.setMonth(date.getMonth() - 12);
			let diff = fecha[1].getTime() - fecha[0].getTime();
			if (diff > 2592000000) {
				this.$message({
					message: 'La diferencia en el rango de fechas no puede ser mayor a 30 dias',
					type: 'warning',
				});
				this.searchForm.rangofecha = '';
			} else if (fecha[0] < date) {
				this.$message({
					message: 'La fecha desde debe estar dentro del último año',
					type: 'warning',
				});
				this.searchForm.rangofecha = '';
			}
		},
		range(array, min: number, max: number): object {
			return array.slice(min, max);
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record: object): void {
			this.detailsDrawer = true;
			this.recordSelected = record;
			this.tableOtros = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		doSearch() {
			this.searchDrawer = false;
			if (!this.responsive.isMobile) {
				// Desktop: el daterange devuelve Date[], generamos strings para enviar:
				const rf = Array.isArray(this.searchForm.rangofecha) ? this.searchForm.rangofecha : [];
				this.searchForm.fechaDesde = rf[0] ? this.convertDate(rf[0]) : ' ';
				this.searchForm.fechaHasta = rf[1] ? this.convertDate(rf[1]) : ' ';
			} else {
				// Mobile: mantené los v-model como Date para validar; generá strings aparte:
				this.searchForm.fechaDesdeM = this.searchForm.fechaDesde ? this.convertDate(this.searchForm.fechaDesde as any) : ' ';
				this.searchForm.fechaHastaM = this.searchForm.fechaHasta ? this.convertDate(this.searchForm.fechaHasta as any) : ' ';
			}
			this.resetData();
			this.callResumen();
		},
		// doSearch(): void {
		// 	this.searchDrawer = false;
		// 	const desde = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[0]
		// 			? this.convertDate(this.searchForm.rangofecha[0])
		// 			: ' '
		// 		: this.searchForm.fechaDesde
		// 		? this.convertDate(this.searchForm.fechaDesde)
		// 		: ' ';
		// 	this.searchForm.fechaDesde = desde;
		// 	const hasta = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[1]
		// 			? this.convertDate(this.searchForm.rangofecha[1])
		// 			: ' '
		// 		: this.searchForm.fechaHasta
		// 		? this.convertDate(this.searchForm.fechaHasta)
		// 		: ' ';
		// 	this.searchForm.fechaHasta = hasta;
		// 	this.resetData();
		// 	this.callResumen();
		// },
		convertDate(inputFormat: Date): string {
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		loadDataResumen(): void {
			this.callResumen();
		},

		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.loadDataResumen();
		},
		doImprimir(type: string): void {
			let config = this.loadConfig();
			let url = './api/public/proxy/cgi/etenet_remitos';
			window.open(
				`${url}?fechadesde=${config.params.fechadesde}&fechahasta=${config.params.fechahasta}&descom=${
					config.params.descom
				}&token=${localStorage.getItem('accessToken')}&files=true&type=${type}&cooperativa=${this.$store.state.config.cuit}&entity_id=${
					axios.defaults.headers.common.Entity_ID
				}`
			);
		},
		downloadFiles(): void {
			let config = this.loadConfig();
			config.params.zip = true;
			config.params.imprime = true;
			let params = {
				url: './api/public/proxy/cgi/etenet_remitos',
				data: config,
			};
			this.descargando = true;
			this.$store.dispatch('downloadFiles', params).then(response => {
				if (!response) {
					this.$notify.error({
						title: 'Error',
						message: 'Error al descargar los archivos',
						position: 'top-right',
					});
				}
				this.descargando = false;
			});
		},
		downloadFile(row): void {
			let record = row ? row : this.recordSelected;
			let url = `./api/public/proxy/files?codcom=${record.codcom}&codtal=${record.codtal}&numero=${record.numero}&cooperativa=${this.$store.state.config.cuit}&type=pdf`;
			window.open(url);
			this.imprimiendo = false;
		},
		resetData(): void {
			this.$store.dispatch('resetItemsRemitos');
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			this.refresh = true;
			let params = {
				start: this.start,
				limit: this.limit,
				data: this.loadConfig(),
			};
			this.$store.dispatch('callResumenRemitos', params).then((response: Fiscal[]) => {
				if (response) {
					response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
					this.loading = false;
					this.refresh = false;
					const conta = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else this.loading = false;
			});
		},
		loadConfig(): object {
			let comprobantes: string[] = [];
			this.searchForm.comprobantes.forEach(element => {
				comprobantes.push(`'${element}'`);
			});
			const fd = this.responsive.isMobile ? this.searchForm.fechaDesdeM : this.searchForm.fechaDesde;
			const fh = this.responsive.isMobile ? this.searchForm.fechaHastaM : this.searchForm.fechaHasta;
			let config = {
				params: {
					fechadesde: fd,
					fechahasta: fh,
					descom: `[${comprobantes}]`,
				},
			};
			return config;
		},
		/*downloadFile(doc): void {
			this.imprimiendo = true;
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom_id, codtal: doc.codtal_id, numero: doc.numero }).then(response => {
				if (response.success) {
					//window.open(`${response.host}/${response.archivo}`);
					//window.location.href = `${response.host}/${response.archivo}`;
					let url = `${response.host}/${response.archivo}`;
					if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) window.open(url, '_blank');
					else window.location.href = url;
					this.imprimiendo = false;
				} else {
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},*/
		downloadFileWsp(doc, aa): void {
			console.log('entidad selected', this.entidadSelected);
			console.log('doc', doc);	
			this.$store.dispatch('downloadFileDirecto', { codcom: doc.codcom, codtal: doc.codtal, numero: doc.numero }).then(response => {
				if (response.success) {
					const host = response.host;
					const comentario = `Hola, podes ver el comprobante de tu pedido en: ${host}/${response.archivo}`; // Reemplaza con el comentario que deseas compartir
					const encodedComentario = encodeURIComponent(comentario);
					const tel = this.entidadSelected.numero_celular;
					const url = tel
						? `https://api.whatsapp.com/send?phone=${tel}&text=${encodedComentario}`
						: `https://api.whatsapp.com/send?&text=${encodedComentario}`;
					//window.open(url, '_blank');
					window.location.href = url;
				} else {
					console.log('error', response);
					this.$message({
						message: response.msg,
						showClose: true,
						type: 'error',
						duration: 0,
					});
				}
			});
		},
		// loadConfig(): object {
		// 	let comprobantes: string[] = [];
		// 	this.searchForm.comprobantes.forEach(element => {
		// 		comprobantes.push(`'${element}'`);
		// 	});
		// 	let config = {
		// 		params: {
		// 			fechadesde: this.searchForm.fechaDesde,
		// 			fechahasta: this.searchForm.fechaHasta,
		// 			descom: `[${comprobantes}]`,
		// 		},
		// 	};
		// 	return config;
		// },
		numberFormatter(row): string {
			return `${row.tvdgi} ${row.letra}  ${row.torig}  ${row.norig}`;
		},
		/*changeResumen(resumen): void {
			this.resumen = resumen;
			this.loading = true;
			this.callResumen();
		},*/
	},
	mounted() {
		this.loading = true;
		let d = new Date();
		d.setMonth(d.getMonth() - 6);
		d.setDate(d.getDate() - (d.getDate() - 1));
		// this.searchForm.fechaDesde = this.convertDate(d);
		this.searchForm.fechaDesde = d;
		this.resetData();
		this.loadDataResumen();
		if (!this.responsive.mobile) window.addEventListener('scroll', this.updateScroll);
		this.window = window;
	},
	destroyed() {
		if (!this.responsive.mobile) window.removeEventListener('scroll', this.updateScroll);
	},
};
